<ng-container *ngIf="syncrvalue===1">
  <i class="fa fa-sync fa-sm"></i>
</ng-container>
<ng-container *ngIf="syncrvalue===0">
  <i class="far fa-times-circle"></i>
</ng-container>
